import React from 'react';
import DataTable from 'react-data-table-component';
import '../../../libs/css/dataTable.css';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';


function CPEndpointTable(props) {
    const { columns, dataTotal, dataList, countPerPage, setPage, isFade } = props;


    return (
        <div className="App">

            <div style={{ opacity: isFade ? '0.3' : 1 }} >
                {
                    isFade ? 
                    <LoadingSpinner /> 
                    :
                    <DataTable
                        className="cp_datatable1 users"
                        title=""
                        columns={columns}
                        data={dataList}
                        highlightOnHover
                        pagination
                        paginationServer
                        paginationTotalRows={dataTotal.total}
                        paginationPerPage={countPerPage}
                        keyField="id"
                        paginationComponentOptions={{
                        noRowsPerPage: true
                        }}
                        onChangePage={page => setPage(page)}
                    />
                }
            </div>
                
            
        </div>
    );
}

export default CPEndpointTable;
